export enum FeatureModule {
  SHOPFLOOR_BOARD = "SHOPFLOOR_BOARD",
  LPA = "LPA",
  INDUSTRIALTRUCKSANALYSIS = "INDUSTRIALTRUCKSANALYSIS",
  POWERBI = "POWERBI",
  ENERGY = "ENERGY",
  PROTOCOL = "PROTOCOL",
  ML = "ML",
}
